import { useState } from 'react'
import type { ThreadRead } from '../../client'
import Modal from '../ui/Modal'
import { useChat } from '../../providers/chat/context'

export default function RenameDialog({ thread, onClose }: { thread: ThreadRead; onClose: () => void }) {
  const { rename } = useChat()
  const [title, setTitle] = useState(thread.title)
  const [saving, setSaving] = useState(false)

  async function save() {
    const next = title.trim()
    if (!next || next === thread.title) {
      onClose()
      return
    }

    setSaving(true)
    try {
      await rename(thread.id, next)
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal title="Rename conversation" width="max-w-sm" onClose={onClose}>
      <input
        autoFocus
        value={title}
        onChange={(event) => setTitle(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') void save()
        }}
        className="w-full rounded-lg border border-stone-300 px-3 py-2 text-sm text-stone-900 focus:border-purple-400 focus:ring-2 focus:ring-purple-100 focus:outline-none"
      />

      <div className="mt-4 flex justify-end gap-2">
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg border border-stone-300 bg-white px-4 py-2 text-sm font-medium text-stone-700 transition hover:bg-stone-50"
        >
          Cancel
        </button>
        <button
          type="button"
          disabled={saving || !title.trim()}
          onClick={() => void save()}
          className="rounded-lg bg-purple-700 px-4 py-2 text-sm font-medium text-white transition hover:bg-purple-800 disabled:opacity-50"
        >
          {saving ? 'Saving…' : 'Rename'}
        </button>
      </div>
    </Modal>
  )
}
